var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      dialog: _vm.show,
      width: "680",
      title: _vm.$t("label_essweb_RosterRecord_dialog_ExportInTitle"),
      maxWidth: "680",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("Stepper", {
              attrs: {
                curStep: _vm.curStep,
                items: _vm.stepper,
                backgroundColor: "white",
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c("FileDragUpdate", {
                                ref: "upload",
                                attrs: {
                                  single: "",
                                  url: "/roster-record/import/",
                                  type: "admin",
                                  curUuid: _vm.curUuid,
                                  reload: _vm.toReload,
                                  tempplateUrl:
                                    "https://assets.essencehr.io/web/ess-business/assets/roster-import-template.xlsx",
                                  title: _vm.$t(
                                    "label_essweb_rosterRecord_dialog_fileLabel"
                                  ),
                                },
                                on: { change: _vm.onChange },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-sheet",
                        {
                          staticClass: "text-center d-flex align-center",
                          attrs: { height: "300" },
                        },
                        [
                          _vm.isSuccess
                            ? _c(
                                "v-sheet",
                                { staticClass: "text-center max-width" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message_essweb_rosterRecord_dialog_exportInSuccessLabel"
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              )
                            : _c(
                                "v-sheet",
                                { staticClass: "text-center max-width" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message_essweb_rosterRecord_dialog_exportInFailLabel"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("br"),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "primary--text text-decoration-underline",
                                      attrs: {
                                        text: "",
                                        ripple: false,
                                        small: "",
                                        rounded: "",
                                        depressed: "",
                                        color: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.showMessage = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_rosterRecord_dialog_errorMessageBtnLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: {
                saveBtn: _vm.curStep != 1,
                saveText: _vm.text,
                okBtnDisabled: _vm.curStep == 1,
              },
              on: {
                save: function ($event) {
                  _vm.curStep == 2 && !_vm.isSuccess
                    ? _vm.toReUpLoad()
                    : _vm.closeDialog()
                },
                cancel: _vm.closeDialog,
              },
            }),
            _c("ErrorMessage", {
              attrs: {
                show: _vm.showMessage,
                items: _vm.fileData,
                downloadUrl: _vm.downloadUrl,
              },
              on: {
                close: function ($event) {
                  _vm.showMessage = false
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }